import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getHealthPlanSlice = createSlice({
  name: "getHealthPlan",
  initialState,
  reducers: {
    getHealthPlanStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getHealthPlanSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getHealthPlanFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getHealthPlanStart,
  getHealthPlanSuccess,
  getHealthPlanFailure,
  clearError,
  clearMessage,
} = getHealthPlanSlice.actions;

export default getHealthPlanSlice.reducer;
